/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";
import { useNavigate } from "react-router-dom";
interface notificationProps {
  listProfile: any;
}

const NotificationSettings: React.FC<notificationProps> = ({ listProfile }) => {
  const navigate = useNavigate();
  const editSound = () => {
    navigate("/settings/sound-update");
  };
  return (
    <div>
      {listProfile?.notification_master?.tone ? (
        <div className="short-bio mb-3">
          <div className="head-line">
            <h6 className="fw-med mb-0">Notification Tone</h6>
            <a href="#" className="text-link" onClick={editSound}>
              Edit
            </a>
          </div>
          <p>
            <span className="tiny">
              {/* Embed the audio player with the source URL */}
              <audio controls>
                <source
                  src={listProfile.notification_master?.tone}
                  type="audio/mpeg"
                />
              </audio>
            </span>
          </p>
        </div>
      ) : (
        <div className="your-cuisine mb-3">
          <a className="empty-wrap" href="#" onClick={editSound}>
            Add your Notification Sound...
            <i className="material-symbols-outlined" onClick={editSound}>
              edit
            </i>
          </a>
        </div>
      )}
    </div>
  );
};

export default NotificationSettings;
